import type { ComponentProps, ReactNode } from "react";
import { cn } from "@/lib/utils";

export function PageCanvas({
  className,
  as: Tag = "div",
  padded = true,
  ...props
}: ComponentProps<"div"> & { as?: "div" | "main"; padded?: boolean }) {
  return (
    <Tag
      {...(Tag === "main" ? { id: "main-content", tabIndex: -1 } : {})}
      className={cn(
        "w-full min-w-0 space-y-section",
        padded && "p-page",
        className,
      )}
      {...props}
    />
  );
}

export function PageHeader({
  title,
  description,
  actions,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header className="flex flex-wrap items-start justify-between gap-4">
      <div className="min-w-0 space-y-2">
        <h1 className="text-page font-display break-words">{title}</h1>
        {description && (
          <div className="text-muted-foreground text-sm">{description}</div>
        )}
      </div>
      {actions && <ActionBar>{actions}</ActionBar>}
    </header>
  );
}

export function ActionBar({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn("flex flex-wrap items-center gap-3", className)}
      {...props}
    />
  );
}

export function RecordSummary({
  title,
  description,
  children,
}: {
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <section className="min-w-0 space-y-3 rounded-lg border bg-card p-4">
      <h2 className="font-semibold break-words">{title}</h2>
      {description && (
        <p className="text-muted-foreground text-sm break-words">
          {description}
        </p>
      )}
      {children}
    </section>
  );
}
